  
/* src/features/5DD/MealLogger.js */
  

import React, { useRef, useState, useEffect, useCallback } from 'react';
import Webcam from 'react-webcam';
import { db, storage } from '../../apiClient';
 
import { aiService } from '../../services/ai';

  
const styles = {
  container: {
  
   
 
  
   
  
   
  
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    width: '100%', boxSizing: 'border-box', maxWidth: '600px', margin: '0 auto'
  },
 
   
 
   
  
  // --- UPDATED STATS BAR (High Contrast + 4 Cols) ---
  
  
   
  
   
 
   
 
  
  
  
   
   
 
   
 
  
 
  
  
   
 
   
  
  
 
   
 
 
  
  statsBar: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '5px',
    width: '100%',
    backgroundColor: 'rgba(20, 20, 20, 0.95)', // High Contrast Dark
    padding: '15px 10px', borderRadius: '12px',
    marginBottom: '15px', border: '1px solid #555',
    boxShadow: '0 4px 6px rgba(0,0,0,0.5)'
 
  
   
   
  },
  statItem: { textAlign: 'center', borderRight: '1px solid #444' },
  statItemLast: { textAlign: 'center' }, // No border for last item
  statValue: { fontSize: '1.4em', fontWeight: 'bold', display: 'block', color: '#fff' },
  statLabel: { fontSize: '0.7em', color: '#aaa', textTransform: 'uppercase', marginTop:'2px' },

  // --- HABIT ROW ---
  habitRow: {
    display: 'flex', justifyContent: 'space-between', gap: '10px', width: '100%',
    marginBottom: '20px'
  },
  habitBtn: {
    flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    padding: '10px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)',
    cursor: 'pointer', transition: 'all 0.2s', minHeight: '70px',
    backgroundColor: 'rgba(40,40,40,0.8)' // Slightly darker default
  },
  habitEmoji: { fontSize: '1.8em', marginBottom: '5px' },
  habitText: { fontSize: '0.75em', fontWeight: 'bold', whiteSpace:'nowrap' },

								   
  activeGold: { backgroundColor: 'rgba(255, 215, 0, 0.2)', borderColor: '#ffd700', color: '#ffd700' },
  activeGreen: { backgroundColor: 'rgba(40, 167, 69, 0.2)', borderColor: '#28a745', color: '#28a745' },
  inactive: { backgroundColor: 'rgba(255,255,255,0.05)', color: '#888' },

  // --- LOG BUTTON ---
  btnBigLog: {
    width: '100%', padding: '15px', backgroundColor: '#007bff', color: 'white',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.2em',
    marginBottom: '20px', boxShadow: '0 4px 10px rgba(0,123,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'
  },

  // --- CAMERA & DRAFT STYLES (Same as before) ---
  cameraModal: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: '#000', zIndex: 9999,
    display: 'flex', flexDirection: 'column', justifyContent: 'center'
  },
	  
  webcamFull: { width: '100%', height: '100%', objectFit: 'cover' },
   
  
   
   
   
 
  
 
   
	
 
  overlayControls: {
    position: 'absolute', bottom: '40px', left: 0, right: 0,
    display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px'
	 
   
	   
	 
 
  },
  btnSnapRound: {
    width: '80px', height: '80px', borderRadius: '50%',
    backgroundColor: 'white', border: '4px solid rgba(0,0,0,0.2)',
    cursor: 'pointer', boxShadow: '0 0 15px rgba(0,0,0,0.5)'
   
  
  
   
   
  
  
   
	
   
	  
	   
   
  },
  btnCloseCam: {
    position: 'absolute', top: '20px', right: '20px',
    background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none',
    padding: '10px 15px', borderRadius: '20px', fontSize: '1em', cursor: 'pointer'
   
   
  
  
 
  
  },

		   
  draftContainer: {
    width: '100%', backgroundColor: 'rgba(30,30,30, 0.95)', // Darker draft background
    padding: '15px', borderRadius: '12px', marginBottom: '20px',
    border: '1px solid #555',
    animation: 'fadeIn 0.3s ease-in-out'
   
 
  
 
   
 
  
	 
 
	   
  
  },
	
  draftHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
	   
	  
	  
 
	 
  previewThumb: { width: '100%', maxHeight: '250px', objectFit: 'cover', borderRadius: '8px', marginBottom: '15px', border: '1px solid #555' },
  
	 
	   
 

  input: {
    width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #555',
    backgroundColor: '#222', color: '#fff', fontSize: '1em', boxSizing: 'border-box',
    marginBottom: '15px'
  },
  btnAnalyze: {
 
   
   
 
  
 
 
  
   
  
	 
  
    width: '100%', padding: '12px', backgroundColor: '#28a745', color: 'white',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em'
  },
  
	   
		
 
  
	   
  historySection: { width: '100%', borderTop: '1px solid #444', paddingTop: '20px' },
  historyItem: {
    display: 'flex', alignItems: 'center', gap: '15px',
    backgroundColor: 'rgba(20,20,20,0.8)', padding: '12px', borderRadius: '10px', marginBottom: '10px', border: '1px solid #333'
  },
  historyThumb: { width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover', backgroundColor:'#333' },
  historyText: { flex: 1 },

	   
  hiddenInput: { display: 'none' }
 
 
  
 
   
		
   
   
   
};
   

function MealLogger({ session, onLogComplete }) {
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);
  
  // State
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [draftImage, setDraftImage] = useState(null);
  const [description, setDescription] = useState('');
  
				  
	
	 
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [draftAnalysis, setDraftAnalysis] = useState(null);
  
  // Data
  const [todayMeals, setTodayMeals] = useState([]);
  const [totals, setTotals] = useState({ cal: 0, prot: 0, carb: 0, fat: 0 }); // Added Carb/Fat
  const [habits, setHabits] = useState({ hh5_count: 0, sleep_logged: false, workout_completed: false });

											 
  const fetchTodayData = useCallback(async () => {
    try {
 
      const today = new Date();
									  
      const todayDateKey = today.toLocaleDateString('en-CA'); 
	  
					  
      today.setHours(0, 0, 0, 0);
      const todayISO = today.toISOString();

      // Meals
      const mealData = await db.meals.list({ date_logged: todayDateKey });
      setTodayMeals(mealData || []);

      let c = 0, p = 0, carbs = 0, fats = 0;
      (mealData || []).forEach(m => {
        if (m.ai_analysis?.nutrition) {
          c += m.ai_analysis.nutrition.calories || 0;
          p += m.ai_analysis.nutrition.protein_g || 0;
          carbs += m.ai_analysis.nutrition.carbs_g || 0;
          fats += m.ai_analysis.nutrition.fat_g || 0;
        }
      });
      setTotals({ cal: c, prot: p, carb: carbs, fat: fats });

      // Habits
      const habitsData = await db.habits.list({ date: todayDateKey });
      const habitData = Array.isArray(habitsData) ? habitsData[0] : habitsData;
      if (habitData) {
        setHabits({
          hh5_count: habitData.hh5_count || 0,
          sleep_logged: habitData.sleep_logged || false,
          workout_completed: habitData.workout_completed || false
        });
      } else {
        setHabits({ hh5_count: 0, sleep_logged: false, workout_completed: false });
      }

    } catch (err) {
      console.error("Error loading data:", err);
    }
  }, [session.user.id]);

  
  useEffect(() => {
    fetchTodayData();
  }, [fetchTodayData]);


							  
  const handleHabitClick = async (type) => {
      const todayDateKey = new Date().toLocaleDateString('en-CA');
      let updates = {};

							
      if (type === 'hh5') {
										
          updates.hh5_count = (habits.hh5_count >= 3) ? 0 : habits.hh5_count + 1;
      } else if (type === 'sleep') {
          updates.sleep_logged = !habits.sleep_logged;
      } else if (type === 'workout') {
          updates.workout_completed = !habits.workout_completed;
      }

											
      setHabits(prev => ({ ...prev, ...updates }));

      try {
						 
										  
          await db.habits.upsert({
              date: todayDateKey,
              ...habits,
              ...updates
          });
          if (onLogComplete) onLogComplete();
								 
					 
      } catch (err) { console.error(err); }
										  
	   
  };
  
   
 
 

  // Handlers for Camera/Upload/AI (Standard)
  const handleStartLog = () => window.innerWidth >= 768 ? fileInputRef.current.click() : setIsCameraOpen(true);
  const handleCapture = useCallback(() => { setDraftImage(webcamRef.current.getScreenshot()); setIsCameraOpen(false); }, [webcamRef]);
  const handleFileUpload = (e) => { 
    if(e.target.files[0]) {
       const r = new FileReader(); 
       r.onloadend=()=>setDraftImage(r.result); 
       r.readAsDataURL(e.target.files[0]); 
    }
  };
  const handleCancelDraft = () => { setDraftImage(null); setDescription(''); setDraftAnalysis(null); };
   
										   
												  
					   
						   
				  
 
   

  
									   
									   
			   
									  
															
								 
	 
	

								   
						
					   
						   
	

	
  const handleAnalyze = async () => {
    if (!draftImage && !description.trim()) return alert("Image or Text required.");
														 
			 
	 
 
    setIsAnalyzing(true);
 

    try {
      const result = await aiService.analyzeMeal(draftImage, description);
      setDraftAnalysis(result); 
				   
 
    } catch (err) { alert("Analysis failed."); } finally { setIsAnalyzing(false); }
			   
							
	 
  };

 
  const handleSaveLog = async () => {
    if (!draftAnalysis) return;
    setIsSaving(true);
   
  
 
  

    try {
      let publicUrl = null;
      if (draftImage) {
        const fileExt = 'jpg';
        const base64Data = draftImage.split(',')[1];
        const buffer = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
        const blob = new Blob([buffer], { type: 'image/jpeg' });
        const uploadFile = new File([blob], `meal_${Date.now()}.${fileExt}`, { type: 'image/jpeg' });
        const uploadResult = await storage.upload('meal-photos', uploadFile, { product: 'hhy' });
        publicUrl = uploadResult.signedUrl || uploadResult.path;
      }

      await db.meals.create({
          image_url: publicUrl,
          comments: description || draftAnalysis.summary,
          ai_analysis: draftAnalysis,
          date_logged: new Date().toISOString()
      });

      handleCancelDraft();
      fetchTodayData();
  
   
  
 
   

	
   
 
  
   
  
	
      if (onLogComplete) onLogComplete();

    } catch (error) { console.error(error); alert("Save failed."); } finally { setIsSaving(false); }
						   
							
			   
						 
	 
  };

				   
 
 
  
 

  return (
    <div style={styles.container}>
      
      {/* 1. NEW 4-COLUMN STATS BAR */}
      <div style={styles.statsBar}>
          <div style={styles.statItem}>
              <span style={{...styles.statValue, color:'#ffd700'}}>{totals.cal}</span>
              <span style={styles.statLabel}>Cals</span>
          </div>
          <div style={styles.statItem}>
              <span style={styles.statValue}>{totals.prot}</span>
              <span style={styles.statLabel}>Prot (g)</span>
          </div>
          <div style={styles.statItem}>
              <span style={styles.statValue}>{totals.carb}</span>
              <span style={styles.statLabel}>Carb (g)</span>
          </div>
          <div style={styles.statItemLast}>
              <span style={styles.statValue}>{totals.fat}</span>
              <span style={styles.statLabel}>Fat (g)</span>
          </div>
      </div>

										  
      {draftImage ? (
          <div style={styles.draftContainer}>
              <div style={styles.draftHeader}>
                  <h3 style={{margin:0, color:'#fff'}}>Review Meal</h3>
                  <button onClick={handleCancelDraft} style={{background:'transparent', border:'none', color:'#ccc', fontSize:'1.2em'}}>✕</button>
              </div>

              <img src={draftImage} alt="Draft" style={styles.previewThumb} />
              
              {!draftAnalysis ? (
                  <>
							
											  
													  
											 
                      <input style={styles.input} placeholder="Description..." value={description} onChange={(e) => setDescription(e.target.value)} />
						
                      <button style={styles.btnAnalyze} onClick={handleAnalyze} disabled={isAnalyzing}>
                          {isAnalyzing ? 'Analyzing...' : 'Analyze Meal'}
                      </button>
                  </>
              ) : (
                  <div>
                      <div style={{textAlign:'center', marginBottom:'15px', backgroundColor:'rgba(0,0,0,0.3)', padding:'10px', borderRadius:'8px', color:'#eee'}}>
                          <p style={{margin:'0 0 5px 0', fontStyle:'italic'}}>"{draftAnalysis.summary}"</p>
                          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'5px', fontWeight:'bold', fontSize:'0.9em'}}>
                              <span style={{color:'#ffd700'}}>{draftAnalysis.nutrition.calories} Cal</span>
                              <span>{draftAnalysis.nutrition.protein_g} P</span>
                              <span>{draftAnalysis.nutrition.carbs_g} C</span>
                              <span>{draftAnalysis.nutrition.fat_g} F</span>
                          </div>
                      </div>
                      <div style={{display:'flex', gap:'10px'}}>
                         <button style={{flex:1, padding:'10px', background:'#6c757d', color:'#fff', border:'none', borderRadius:'6px'}} onClick={() => setDraftAnalysis(null)}>Edit</button>
                         <button style={{flex:2, padding:'10px', background:'#28a745', color:'#fff', border:'none', borderRadius:'6px', fontWeight:'bold'}} onClick={handleSaveLog} disabled={isSaving}>
                            {isSaving ? 'Saving...' : 'Confirm'}
                         </button>
                      </div>
                  </div>
              )}
          </div>
      ) : (
							  
         <>
											  
            <div style={styles.habitRow}>
								  
					 
                <div style={{...styles.habitBtn, ...(habits.hh5_count > 0 ? styles.activeGold : styles.inactive)}} onClick={() => handleHabitClick('hh5')}>
														   
				 
                    <span style={styles.habitEmoji}>🧘</span>
                    <span style={styles.habitText}>HH5: {habits.hh5_count}/3</span>
                </div>

									
					 
                <div style={{...styles.habitBtn, ...(habits.sleep_logged ? styles.activeGreen : styles.inactive)}} onClick={() => handleHabitClick('sleep')}>
															 
				 
                    <span style={styles.habitEmoji}>💤</span>
                    <span style={styles.habitText}>{habits.sleep_logged ? 'Slept' : 'Sleep'}</span>
                </div>

									  
					 
                <div style={{...styles.habitBtn, ...(habits.workout_completed ? styles.activeGreen : styles.inactive)}} onClick={() => handleHabitClick('workout')}>
															   
				 
                    <span style={styles.habitEmoji}>🏋️</span>
                    <span style={styles.habitText}>{habits.workout_completed ? 'Done' : 'Workout'}</span>
                </div>
            </div>

										   
            <button style={styles.btnBigLog} onClick={handleStartLog}>
                <span>📸</span> Log New Meal
            </button>
            <input type="file" accept="image/*" ref={fileInputRef} style={styles.hiddenInput} onChange={handleFileUpload}/>

								
            <div style={styles.historySection}>
                <div style={{color:'#aaa', marginBottom:'10px', paddingLeft:'5px', fontWeight:'bold'}}>TODAY'S MEALS</div>
																																						   
	
                {todayMeals.map(meal => (
                    <div key={meal.id} style={styles.historyItem}>
										   
  
 
   
                        {meal.image_url ? <img src={meal.image_url} alt="Meal" style={styles.historyThumb} /> : <div style={styles.historyThumb}></div>}
							 
																   
						  
                        <div style={styles.historyText}>
                            <div style={{fontWeight:'bold', fontSize:'0.95em', color:'#fff'}}>{meal.comments}</div>
                            <div style={{color:'#ccc', fontSize:'0.85em'}}>
                                {meal.ai_analysis?.nutrition?.calories || 0} Cal | {meal.ai_analysis?.nutrition?.protein_g || 0}g P | {meal.ai_analysis?.nutrition?.carbs_g || 0}g C
                            </div>
                        </div>
                    </div>
                ))}
            </div>
   
 
 
	
  
 
  
   
   

   
  
 
   
 
   
 
  
   
 
   
 
   
   

  
   
  
   
 
  
  
 
         </>
      )}

							 
      {isCameraOpen && (
   
          <div style={styles.cameraModal}>
              <button style={styles.btnCloseCam} onClick={() => setIsCameraOpen(false)}>Close</button>
	 
					 
																			 
              <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" style={styles.webcamFull} videoConstraints={{ facingMode: 'environment' }} />
				
	 
              <div style={styles.overlayControls}>
	 
  
	
	   
	
	   
   
 
   
 

	
	
  
	 
   
	 
	  
		
	  
			
	
   
	 
   
	
   
	   
		
   
	
	  
                  <button style={styles.btnSnapRound} onClick={handleCapture}></button>
              </div>
   
	
   
		 
	   
   
		   
   
	
   
   
  

	
  
	 
	  
	
	  
	

	 
	  
	  
		
	   
   
  
   
 

	
   
	

 
   
 
 
   
  

 
 
  
   
  
  

  

 
 
 
  
 
 
 

 
  
 
 
   
  
 
 
   
  
   
  
 
 
 

   

 

 
   
   
 
   
   
   
   


   

   
 
  
 
   
  
  
 
 
   
  
   
   
   
  

  
   
  
 
  
 
   
   
 
 
 
  
 
  
   
 
  
   
   

   
  
 
   
   
  

   
 
   
 
   
  
  
   
 
 
   
  
   
  
   
  
 
 
   
   
   
  
 
 
 
 
   
  
   
  
   
  
 
 
   

  
  
  
   
 
   
   
   
 
   
   
 
  
   
 
  
 
  

   
 
 
  
   
  
 
   
   
 
   
 
 
 

  
  
 
 
   
   
 
  
   
   
 
 
 
   
  
 
 
 
  
   
  
  
 

  
	 
	
		  
		 
	   
   
 
  
  
  
  
	
  
	 
		   
	   
	 
	 
	
   
 
          </div>
      )}
   
   
   
 
  
  
 
   
  
  
  
  

   
  
   
  
   
 
   
 
   

   
   
   
 
   
 
 
  
 
  
 
 
 

    </div>
  
  );
}

export default MealLogger;